import {useForm} from "laravel-precognition-vue";

export const useCreateForm = (url, data, config = {}) => {
    return useForm('post', url, data, config);
}

export const useEditForm = (url, data, config = {}) => {
    return useForm('put', url, data, config);
}

export const mergeOptionsParams = (params, tableName, columns = ['id', 'name']) => {

    if (!params.hasOwnProperty('per_page')) {
        params.per_page = 10_000;
    }

    if (!params.fields) {
        params.fields = {[tableName]: []}
    }

    if (!params.fields[tableName]) {
        params.fields[tableName] = [];
    }

    if (typeof params.fields[tableName] === 'string') {
        params.fields[tableName] = params.fields[tableName].split(',');
    }

    params.fields[tableName].push(...columns);

    if (!params.include) {
        params.include = [];
    }

    return params;
}



// shared functionality for the indexPageStores that use a DataTable
export const onPage = ($event, params) => {
    params.page = $event.page + 1;
};
export const onSort = ($event, params) => {
    params.sort = $event.sortOrder === -1
        ? `-${$event.sortField}`
        : $event.sortField;
    params.page = 1;
};
export const onRowsUpdate = (rowCount, params) => {
    params.per_page = rowCount;
};
export const onFilter = ($event, params) => {
    Object.entries($event.filters).forEach(([column, filterCriteria]) => {
        params.filter[column] = filterCriteria.value === null ? undefined : filterCriteria.value;
    });
    params.page = 1;
};
export const onSearch = (params) => {
    if (params.filter.search === '') {
        params.filter.search = null;
    }
    params.page = 1;
}
export const getFirstPage = (params) => {
    return params.page === 1 ? 0 : (params.page - 1) * params.per_page
};